import { useFirebaseContext } from 'context/firebase';
import { useTranslation } from 'react-i18next';
// import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
// dependences
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// images
import logo from 'assets/header/smileLogo.svg';
import darkLogo from 'assets/header/darkSmileLogo.svg';
// styles
import scrollToTop from 'utils/scrollToTop';
import { activeSectionKey, rememberSection } from '../isActiveLink';
import css from './css.module.scss';
import DetermineNavigation from '../DetermineNavigation';
import SpecialistCta from '../SpecialistCta';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { FiChevronDown, FiGlobe } from 'react-icons/fi';
import MegaMenu from './MegaMenu';

export const SmartLogin = () => {
  const [t] = useTranslation('global');

  const {
    authEnabled,
    loginWithGoogle,
    currentUser,
    logout,
  } = useFirebaseContext();
  if (authEnabled && currentUser) {
    return (
      <button type="button" onClick={logout}>
        {currentUser.displayName}
      </button>
    );
  }

  if (authEnabled) {
    return (
      <button type="button" onClick={loginWithGoogle}>Admin Sign In</button>
    );
  }
  return (
    <button
      type="button"
      onClick={() => window.open('https://dashboard.smileweb.net')}
    >
      {t('header.sign-in')}
    </button>
  );
};

const CLOSE_DELAY = 140;

const DesktopMenu = ({
  changeLanguage,
  i18n,
  language,
  languagesList,
  navItems,
  sendDemoEvent,
  showLanguages,
  showLanguagesFn,
  advertisingView,
  version2,
  pathname,
  onMenuOpen,
}) => {
  const [openKey, setOpenKey] = useState(null);
  // keeps the last opened menu rendered while the panel animates out
  const [shownKey, setShownKey] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const closeTimer = useRef(null);

  const openMenu = (key) => {
    clearTimeout(closeTimer.current);
    setOpenKey(key);
    if (key) {
      setShownKey(key);
      onMenuOpen(key);
    }
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpenKey(null), CLOSE_DELAY);
  };
  const closeNow = () => {
    clearTimeout(closeTimer.current);
    setOpenKey(null);
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    const onKey = (e) => e.key === 'Escape' && setOpenKey(null);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('keydown', onKey);
      clearTimeout(closeTimer.current);
    };
  }, []);

  useEffect(() => {
    clearTimeout(closeTimer.current);
    setOpenKey(null);
  }, [pathname]);

  const shownItem = navItems.find((item) => item.key === shownKey && item.menu);
  // only one menu is marked, even when the page is listed in several
  const currentSection = activeSectionKey(navItems, pathname || '');
  const isSectionActive = (item) => item.key === currentSection;

  return (
  <div
    className={clsx(
      css.container,
      (advertisingView && version2) && css['dark-container'],
      scrolled && css.scrolled,
      openKey && css.menuOpen,
    )}
    onMouseLeave={scheduleClose}
  >
    <header>
      <Link to={advertisingView ? "#" : `/${language}/`} onClick={scrollToTop} className={css.logoLink}>
        <img width='100%' height='100%' loading="lazy" className={css.logo} src={(advertisingView && version2) ? darkLogo : logo} alt="smile logo" />
      </Link>
      <nav className={css.center}>
        <ul>
          {navItems.map((item) => (
            <li
              key={item.key || item.path}
              onMouseEnter={() => openMenu(item.menu ? item.key : null)}
              onFocus={() => item.menu && openMenu(item.key)}
            >
              {item.menu ? (
                // hover opens the menu; a click goes to the section's main page
                <Link
                  to={item.path}
                  className={clsx(
                    css.navItem,
                    css.navTrigger,
                    openKey === item.key && css.navTriggerOpen,
                    isSectionActive(item) && css.active,
                  )}
                  aria-haspopup="true"
                  aria-expanded={openKey === item.key}
                  onClick={() => {
                    rememberSection(item.key, item.path);
                    closeNow();
                  }}
                >
                  {item.title}
                  <FiChevronDown className={css.chevron} />
                </Link>
              ) : (
                <DetermineNavigation css={css} item={item} advertisingView={advertisingView} />
              )}
            </li>
          ))}
        </ul>
      </nav>
      <div className={css.right}>
        {!advertisingView && (
          <div className={css.languages}>
            <FiGlobe className={css.globe} />
            {languagesList.map((lang) => (
              <button
                key={lang}
                type="button"
                className={clsx(css.langOption, i18n.language === lang && css.langActive)}
                onClick={() => changeLanguage(lang)}
              >
                {lang}
              </button>
            ))}
          </div>
        )}
        {!advertisingView && <div className={css.signIn}><SmartLogin /></div>}
        <div className={css.cta}>
          <SpecialistCta language={language} advertisingView={advertisingView} sendDemoEvent={sendDemoEvent} />
        </div>
      </div>
    </header>
    <MegaMenu item={shownItem} open={Boolean(openKey)} onNavigate={closeNow} activeSection={currentSection} />
  </div>
  );
};

DesktopMenu.defaultProps = {
  changeLanguage: () => { },
  showLanguagesFn: () => { },
  showLanguages: false,
  pathname: '',
  onMenuOpen: () => {},
};

DesktopMenu.propTypes = {
  changeLanguage: PropTypes.func,
  showLanguagesFn: PropTypes.func,
  navItems: PropTypes.array.isRequired,
  languagesList: PropTypes.array.isRequired,
  showLanguages: PropTypes.bool,
  i18n: PropTypes.any.isRequired,
  pathname: PropTypes.string,
  onMenuOpen: PropTypes.func,
};
export default DesktopMenu;
